module.exports = __webpack_public_path__ + "static/deal-min-76d0cd3563c62319a256c6cbcd026a9e.jpg";